var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookmetrieicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3980_90658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3661 11.2251L16.2929 3.99619C14.4701 3.09242 12.491 2.8451 10.8768 3.28147L10.8801 3.28242C8.90975 4.92334 7.41303 8.91665 7.34276 9.03656L7.13372 9.0901C7.46812 7.66494 8.83743 3.97004 9.59955 3.56017C8.47645 2.60571 6.72961 2.27006 4.60944 2.75977L1.33887 9.53937C3.26271 9.37105 5.18226 9.57682 6.49726 11.1145C8.61001 10.2172 10.5494 10.3834 12.3661 11.2251Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1341 9.13855L13.9536 15.0921C13.9168 15.1611 13.8301 15.1863 13.7612 15.1494C10.9963 13.6649 8.78043 13.3772 6.09893 14.9836C6.02861 15.0257 5.93566 14.9999 5.89704 14.9276C4.81431 12.9004 3.50234 12.0654 1.96334 11.7237C1.80194 11.6879 1.80536 11.457 1.97066 11.454C3.44243 11.4269 5.03526 11.8816 6.40597 13.6133C9.07078 12.0727 11.0164 12.1625 13.4595 13.5608L16.0581 8.52074L14.6993 8.37049L17.9144 6.39526L18.1184 10.1546L17.1341 9.13855Z",
    fill: "#252525"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3980_90658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmetrieicon);
export default __webpack_public_path__ + "static/media/bookmetrie.icon.ed28ec85b2e21d811d7cb232a1c1f78a.svg";
export { ForwardRef as ReactComponent };